// Model
import { Employee2 } from '../../../../../../model/Employee';

export const deleteEmployee = async (employee: Employee2) => {
    const headers = new Headers({
        "Content-Type": "application/json",
        Authorization: `${process.env.REACT_APP_API_KEY}`,
    });

    const response = await fetch(
        `${process.env.REACT_APP_API_URL_V2}/karyawan?nik=${employee?.nik}&nama=${encodeURIComponent(employee?.nama)}`,
        { method: "DELETE", headers }
    );

    if (!response.ok) {
        throw new Error(`HTTP Error: ${response.status}`);
    }

    return await response.json();
};